import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import BooksSection from './components/BooksSection';
import CharactersSection from './components/CharactersSection';
import WorldSection from './components/WorldSection';
import AuthorSection from './components/AuthorSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Hero />
        <BooksSection />
        <CharactersSection />
        <WorldSection />
        <AuthorSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
